import { Form, Offcanvas, Button, Row, Col, InputGroup } from "react-bootstrap";
import TextEditor from "../../PageSettings/TextEditor";
import { CiSquarePlus } from "react-icons/ci";
import { useEffect, useState } from "react";
import { blogSubCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogSubCategoryServices";
import { GoTrash } from "react-icons/go";
import { blogPostServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogPostServices";

const AddBlogPost = ({
  show,
  hide,
  title,
  blogCategories,
  getBlogPostList
}) => {
  const [blogTitle, setBlogTitle] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [blogSubCategories, setBlogSubCategories] = useState([]);
  const [status, setStatus] = useState("draft");
  const [loader, setLoader] = useState(false);

  const addNewBlogPost = async () => {
    setLoader(true)
    let userData = {}
    userData.title = blogTitle
    userData.categoryId = categoryId
    userData.subCategoryId = subCategoryId
    userData.status = status
    userData.shortDescription = shortDescription
    userData.longDescription = longDescription
    userData.tags = tags
    let data = await blogPostServices.addNewBlogPost(userData)
    if (data?.statusCode === 200) {
      getBlogPostList()
      clearData();
    }
    setLoader(false)
  }

  const clearData = () => {
    setBlogTitle("");
    setCategoryId("");
    setSubCategoryId("");
    setShortDescription("");
    setLongDescription("");
    setTags([]);
    setStatus("draft");
    setLoader(false)
    hide();
  }

  const getBlogSubCategoryList = async () => {
    let data = await blogSubCategoryServices.getBlogSubCategoryList(
      categoryId,
      "active",
    );
    setBlogSubCategories(data?.data || []);
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  const hasEmptyTag = () => {
    return tags?.some(tag => tag.trim() === "");
  };

  useEffect(() => {
    if (!show) {
      setBlogTitle("");
      setCategoryId("");
      setSubCategoryId("");
      setShortDescription("");
      setLongDescription("");
      setTags([]);
      setStatus("draft");
      setLoader(false)
    }
  }, [show]);

  useEffect(() => {
    if (categoryId) {
      getBlogSubCategoryList()
    }
  }, [categoryId]);
  return (
    <Offcanvas show={show} onHide={hide} placement="end" style={{ width: 750 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Blog Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Title"
              value={blogTitle}
              onChange={(e) => setBlogTitle(e.target.value)}
            />
          </Form.Group>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                >
                  <option value={""}>Select category</option>
                  {blogCategories?.map(item => (
                    <option value={item?.categoryId}>{item?.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Sub Category</Form.Label>
                <Form.Select
                  value={subCategoryId}
                  onChange={(e) => setSubCategoryId(e.target.value)}
                >
                  <option value={""}>Select Sub Category</option>
                  {blogSubCategories?.map(item => (
                    <option value={item?.subCategoryId}>{item?.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Cover Image</Form.Label>
                <Form.Control type="file" />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value={"draft"}>Draft</option>
                  <option value={"publish"}>Published</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Short Description</Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Enter Short Description"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Long Description</Form.Label>
            <TextEditor
              placeholder={"Write your blog content here..."}
              editorContent={longDescription}
              setEditorContent={(value) =>
                setLongDescription(value)
              }
            />
          </Form.Group>
          <Form.Group>
            <div className="hstack gap-2">
              <Form.Label>Tags</Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addTagsRow}
                className="mb-1 text-success CP"
              />
            </div>
            <Row>
              {tags?.map((tag, index) => {
                return (
                  <Col md={3} className="mb-2">
                    <InputGroup key={index} className="mb-2">
                      <Form.Control
                        placeholder="Enter Tag"
                        value={tag}
                        onChange={(e) =>
                          handleTagsChange(
                            index,
                            e.target.value,
                          )
                        }
                      />
                      <InputGroup.Text>
                        <GoTrash
                          style={{ fontSize: 15 }}
                          className="text-danger CP"
                          title="Delete"
                          onClick={() =>
                            removeTagsRow(index)
                          }
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                );
              })}
            </Row>
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" style={{ fontSize: 12 }} onClick={clearData}>
              Cancel
            </Button>

            <Button
              disabled={
                !blogTitle ||
                !categoryId ||
                !subCategoryId ||
                !status ||
                !shortDescription ||
                !longDescription ||
                loader ||
                hasEmptyTag()
              }
              onClick={addNewBlogPost}
              style={{ fontSize: 12 }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddBlogPost;
